function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("path", {
  d: "M15 7.03V15a1 1 0 01-1 1H2a1 1 0 01-1-1V7.03c.6.3 1.28.47 2 .47V12h10V7.5c.72 0 1.4-.17 2-.47zM13.46 0a1 1 0 01.84.45L16 3a3 3 0 01-5.5 1.66 3 3 0 01-5 0A3 3 0 010 3L1.7.45A1 1 0 012.54 0h10.92z"
})));